import { Path } from '@aloft/toolkit-shared';
import { TypographyVariant } from '@aloft/toolkit-sui';

import { get } from 'lodash';

import { Td } from '../../summary/components/Td.tsx';
import { Tr } from '../../summary/components/Tr.tsx';
import { Typography } from '../../summary/components/Typography.tsx';
import { SummaryTableExtraCells } from './SummaryTableExtraCells.tsx';
import { COMPS_PER_TABLE } from './constants.ts';
import { PropertyMetadata, Tkv2PairedCostSummaryInterfaceV2, ValueFormatter } from './types.ts';
import { noop } from './utils/formatters/noop.ts';

export const SummaryTableRowFromMetadataStringProperty = ({
  section,
  sequence,
  label,
  path,
  formatter = noop,
  typeVariant = 'body2',
  isFirstRow,
}: {
  section: Tkv2PairedCostSummaryInterfaceV2;
  sequence: string[];
  label: string;
  path: Path<PropertyMetadata>;
  formatter?: ValueFormatter;
  typeVariant?: TypographyVariant;
  isFirstRow?: boolean;
}) => {
  const { str: subjStr, color: subjColor } = formatter(get(section.subjectMetadata, path));
  return (
    <Tr>
      <Td width="16%" isFirstColumn={true} isFirstRow={isFirstRow}>
        <Typography variant={typeVariant}>{label}</Typography>
      </Td>
      <Td width="12%" textAlign="right" isFirstRow={isFirstRow}>
        {subjStr.map((string, idx) => (
          <Typography key={idx} variant="body2" color={subjColor}>
            {string}
          </Typography>
        ))}
      </Td>
      {sequence.map((compId) => {
        const { str, color } = formatter(get(section.compMetadata[compId], path));

        return (
          <Td
            key={`${compId}-${path}`}
            colSpan={2}
            width="24%"
            textAlign="right"
            isFirstRow={isFirstRow}
          >
            {str.map((string, idx) => (
              <Typography key={idx} variant="body2" color={color}>
                {string}
              </Typography>
            ))}
          </Td>
        );
      })}
      <SummaryTableExtraCells count={COMPS_PER_TABLE - sequence.length} span={2} />
    </Tr>
  );
};
